import React from 'react';
import { formatCompactTonnes } from '../utils/formatNumber';

const InventorySection = ({ data, currentScreen, containerData }) => {
  // Transform container data for display
  const getInventoryData = () => {
    if (!containerData) {
      return [];
    }

    if (currentScreen.includes('DRC')) {
      // For DRC, show data by comptoir
      return [
        { name: 'BASEMIN', quantity: (containerData.basemin?.total_weight || 0) },
        { name: 'LUMA', quantity: (containerData.luma?.total_weight || 0) },
        { name: 'LIMC', quantity: (containerData.limc?.total_weight || 0) },
        { name: 'MAWEX', quantity: (containerData.mawex?.total_weight || 0) }
      ];
    } else {
      // For Rwanda, show data by location
      return [
        { name: 'With RMR', quantity: (containerData.rmr_container?.total_weight || 0) },
        { name: 'With Minexx', quantity: (containerData.minexx_container?.total_weight || 0) },
        { name: 'Pending Shipment', quantity: (containerData.pending_shipment?.total_weight || 0) }
      ];
    }
  };

  const inventoryData = getInventoryData();

  return (
    <div className="bg-[#252836] rounded-xl p-6 border border-gray-700">
      <h2 className="text-xl font-semibold mb-6">
        {currentScreen.includes('DRC') ? 'Inventory by Comptoir' : 'Inventory by Location'}
      </h2>

      <div className="space-y-4">
        <div className="flex justify-between text-sm text-gray-400 border-b border-gray-700 pb-2">
          <span>{currentScreen.includes('DRC') ? 'COMPTOIR NAME' : 'LOCATION'}</span>
          <span>QUANTITY</span>
        </div>

        {inventoryData && inventoryData.map((item, index) => (
          <div key={`${currentScreen}-${index}`} className="flex justify-between items-center">
            <span className="text-white">{item.name}</span>
            <span className="text-white">
              {formatCompactTonnes(item.quantity)} <span className="text-gray-400 text-sm">tonnes</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InventorySection;